import React, { useEffect, useState } from 'react';
import './styles/LoginModal.css';
import { CloseSmall, User, Lock } from '@icon-park/react';
import { login } from '../../../api/auth';

function LoginModal({ isOpen, onClose, onSwitchToRegister, onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setError('');
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('请输入账号和密码');
      return;
    }

    setError('');
    setIsSubmitting(true);
    try {
      const user = await login({ username, password });
      if (onLoginSuccess) {
        onLoginSuccess(user);
      }
    } catch (loginError) {
      setError(loginError.message || '登录失败，请稍后再试');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <CloseSmall theme="outline" size={20} fill="#64748b" strokeWidth={3} />
        </button>
        
        <h2 className="modal-title">欢迎回来</h2>
        <p className="modal-subtitle">登录您的账户，继续使用数字标签服务</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="form-error">⚠️ {error}</div>}
          
          <div className="form-group">
            <label className="form-label">账户名称</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <User theme="outline" size={20} fill="currentColor" strokeWidth={3} />
              </span>
              <input
                type="text"
                placeholder="请输入您的账户名"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-input"
                autoComplete="username"
              />
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label">登录密码</label>
            <div className="input-wrapper">
              <span className="input-icon">
                <Lock theme="outline" size={20} fill="currentColor" strokeWidth={3} />
              </span>
              <input
                type="password"
                placeholder="请输入您的密码"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                autoComplete="current-password"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <a href="#" className="forgot-password">忘记密码？</a>
          </div>
          
          <button type="submit" className="btn-login" disabled={isSubmitting}>
            {isSubmitting ? '登录中...' : '登录'}
          </button>
          
          <div className="switch-form">
            还没有账号？<a href="#" onClick={onSwitchToRegister}>立即注册</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;
